import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToHashElement() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const elementId = location.hash.replace("#", "");
      const scrollToElement = () => {
        const section = document.getElementById(elementId);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      };

      // Try immediately, and again after small delay (for mobile render delay)
      scrollToElement();
      setTimeout(scrollToElement, 500);
    }
  }, [location]);

  return null;
}

export default ScrollToHashElement;
